import styled from "styled-components";

import check_box from "../_assets/images/check_box.png";
import check from "../_assets/images/check.png";
import check2 from "../_assets/images/check2.png";


export const ContentComponent = styled.main`
    background-color: #000;
    color: #fff;
    display: flex;
    flex-direction: column;
    position: relative;

    button, a { cursor: pointer; }    

    article {
        width: 100%;
        height: auto;
        position: relative;
    }

    .support-cont {
        display: ${ props => props.spyEle === "" ? 'none !important' : 'block' }; 
        position: fixed;
        bottom: 4.6%;
        right: 2.6%;
        width: fit-content;
        margin: 0;
        padding: 0;
        background: transparent;
        border: 0;
    }
    .support-cont button {
        cursor: pointer;
        background: transparent;
        border: 0;
        margin: 0;
        padding: 0;
    }
    .support-cont2 {
        ${ props => props.spyEle !== "" && props.supportVisible === true ? `
        display: flex; transform: translateY(0%);` : `display: none; transform: translateY(100%);` }; 
        width: auto;
        position: fixed;
        right: 0;
        bottom: -1%;
        top: unset;
        background-color: transparent;
        border: 0;
        margin: 0 auto;
        transition: all 0.5s ease;
    }
    
    .support-cont2 img {
        width: 100%;
    }    

    .logo {
        position: fixed;
        top: 3rem;
        left: 2%;
        width: 7.5rem;
        z-index: 2;
    }

    .logo-cont img { width: 7.5rem; }

    .btn-cont {
        ${(props) => props.spyEle === '' ? 
        `
        margin-top: 4rem;
        text-align: center;
        height: fit-content;
        ` : `
        position: fixed;
        width: 100%;
        text-align: center;        
        top: 0 !important;
        bottom: auto;
        background: #ffffffc9;
        height: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        `
        }
    }

    .btn-cont a, & button {
        font-family: 'Noto Sans KR',sans-serif;
        font-weight: 700;
        cursor: pointer;
        display: inline-block;
        text-decoration: none;
        ${(props) => props.spyEle === '' ?
        `
            margin: 0 1.5rem;
            border: 0;
            padding: 0 0 .4rem 0;
            background-color: #1CABE2;
            border-radius: 2rem;
            font-size: 1.69rem;
            width: 20rem;
            line-height: 3rem;
            overflow: hidden;
            color: white;
            & img {
            width: 100%;
            }
        ` : `
            margin: 0 2rem;
            border: 2.5px solid #000;
            color: #000;
            padding: 0.9rem 3.8rem 1rem;
            border-radius: 100px;
            font-size: 1.9rem;
        `
        }
    }

    .btn-cont2 {
        ${(props) => props.spyEle === '' ?
        `
        position: absolute;
        width: 100%;
        text-align: center;
        top: 1.65%;
        height: fit-content;
        ` : `
        position: fixed;
        width: 100%;
        text-align: center;
        top: 0 !important;
        bottom: auto;
        background: #ffffffc9;
        height: 10rem;
        display: flex;
        justify-content: center;
        align-items: center;
        `
        }
    }

    .btn-cont2 a {
        font-family: 'Noto Sans KR',sans-serif;
        font-weight: 700;
        cursor: pointer;
        display: inline-block;
        ${(props) => props.spyEle === '' ?
        `
            margin: 0 1rem;
            border: 0;
            padding: 0 0 .4rem 0;
            background-color: #1CABE2;
            border-radius: 25px;
            font-size: 1.69rem;
            width: 20rem;
            overflow: hidden;
            top: 2%;

            & img {
                width: 100%;
            }
        ` : `
            margin: 0 1.5rem;
            border: 2.5px solid #000;
            color: #000;
            padding: 0.9rem 1.5rem 1rem;
            border-radius: 100px;
            font-size: 1.9rem;
        `
        }
    }

    .btn-cont a img, .btn-cont2 a img {
        display: ${(props) => props.spyEle === '' ? 'block' : 'none'};
    }
        
    .btn-cont a.active, .btn-cont2 a.active {
        background-color: #1CABE2;
        color: #fff;
        border: ${(props) => props.spyEle === '' ? '0' : '2px solid #1CABE2;'};
    }
    .btn-cont a:hover{
        ${(props) => props.spyEle === '' ?
        `
            background-color: #1CABE2;
            color: #fff;
            border: 8px solid #fff;
            margin: -8px calc(1.5rem - 8px);
        `: `
            background-color: #1CABE2;
            color: #fff;
            border: 2.5px solid #fff;
        `
        }
    }
    .btn-cont2 a:hover {
        ${(props) => props.spyEle === '' ?
        `
            background-color: #1CABE2;
            color: #fff;
            border: 8px solid #fff;
            margin: -8px calc(1rem - 8px);
        `: `
            background-color: #1CABE2;
            color: #fff;
            border: 2.5px solid #fff;
        `
        }
    }

    @media (max-width: 720px) {        
        .btn-cont {
            ${(props) => props.spyEle === "" ?
                `
                top: 3% !important;
                bottom: auto;
                height: auto;
                ` : `
                top: 0 !important;
                bottom: auto;
                background: #ffffffc9;
                height: 9rem;
                `
            }
        }
        .btn-cont2 {
            ${(props) => props.spyEle === "" ?
                `
                top: 1.7% !important;
                bottom: auto;
                height: auto;
                ` : `
                top: 0% !important;
                bottom: auto;
                background: #ffffffc9;
                height: 9rem;
                `
            }
        }

        .btn-cont a {
            ${props => props.spyEle === "" ? `
            display: block;
            margin: 1.6rem auto;
            padding: 1rem 4.5rem;
            width: fit-content;
            background: none;
            border: 2.5px solid;
            font-size: 2.3rem;
            ` : `
            display: inline-block;
            margin: 2rem 1rem 0;
            padding: 1rem 2rem;
            width: fit-content;
            border: 2.5px solid;
            color: #000;
            font-size: 1.74rem;
            `};
            border-radius: 100px;
        }
        
        .btn-cont a.active, .btn-cont2 a.active {
            color: #fff;
            
            ${props => props.spyEle === "" ? `
                border: 2.5px solid;;
                background: transparent
            ` : `
            `};

        }

        .btn-cont2 a, & button {
            ${props => props.spyEle === "" ? `
            display: block;
            margin: 2rem auto;
            padding: 1rem 1.5rem;
            width: fit-content;
            background: none;
            border: 2.5px solid;
            font-size: 1.74rem;
            ` : `
            display: inline-block;
            margin: 2rem 1rem 0;
            padding: 0 2rem;
            width: 17%;
            border: 2.5px solid;
            color: #000;
            font-size: 1.4rem;
            `};
            border-radius: 100px;
            }

        
        .btn-cont a:hover {  
            background-color: #1cabe2;
            color: #fff;
            
            ${props => props.spyEle === "" ? `
            margin: 1.6rem auto;
            border: 2.5px solid #fff;
            ` :
            `
            `}
        }

        .btn-cont2 a:hover {
            background-color: #1cabe2;
            color: #fff;
            
            ${props => props.spyEle === "" ? `
            margin: 2rem auto;
            border: 2.5px solid !important;
            ` : 
            ``
            }
        }

        button {width: fit-content !important;}

        .support-cont { display: none; }
    }
`;

export const MainContainer = styled.section`
    width: inherit;


    nav {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    nav a {
        font-family: 'Noto Sans KR',sans-serif;
        font-weight: 700;
        width: 50%;
        display: inline-block;
        text-align: center;
        padding: 1.16rem 0;
        cursor: pointer;
        color: #fff;
        font-size: 1.9rem;
        text-decoration: none;
        background-color: #737373;
    }
    .active-tab {
        background-color: #00aeef;
    }

    .main-inner {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%
    }
    .main-inner img { width: 6.5rem; }
    .main-inner p {
        font-family: 'Noto Sans KR',sans-serif;
        font-size: 1.9rem;
    }

    .main-comm {
        text-align: center;
    }
    .main-comm h1 {
        font-size: 2.815rem;
        font-family: AggroB, sans-serif;
        margin: 0;
    }
    .main-comm p {
        font-family: AggroM, sans-serif;
        font-size: 2.19rem;
        margin: 1rem 0 4.13rem;
    }

    .scroll-txt {
        font-family: 'SUIT', sans-serif;
        writing-mode: vertical-rl;
        position: absolute;
        bottom: 5%;
        left: 2%;
        font-size: 1.07rem;
        height: 175px;
        animation: bounce .6s linear infinite;
    }
    .scroll-txt img {
        margin-top: 0.5rem;
        display: inline-block;
        width: 0.6rem;
    }

    .qa-cont {
        background: url(${"http://cdn.unicef.or.kr/images/22unicef-asmr/static/media/qa_bg.ac02be1a07e29d5f24e6.jpg"}) no-repeat center / cover;
    }

    .qa-cont .main-comm p {
        font-family: AggroL, sans-serif;
        font-size: 2.2rem;
        margin: 1rem 0 3rem;
    }
    .p-1-w {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg1.d7e0d8990bf3c0d86609.jpg" }) no-repeat center / cover;
    }
    .p-1-m {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg1.9f832953cec054d1ab4b.jpg" }) no-repeat center / cover;
    }
    .p-3 {
        background: url(${(props) => props.spyEle === 'war' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg2.800bf4e8590d8b26ebfb.png" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg2.85dca3451ae3c5873cda.png" }) no-repeat center right / 60%, #000;
        align-items: flex-start;
    }
    .p-3 .comm, .p-13 .comm {
        text-align: left;
        padding-left: 10%;
    }
    .p-4 { justify-content: flex-end; }
    .p-4 .comm {
        height: 80%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-bottom: 4rem;
    }
    .p-4 .comm > div {
        display: flex;
        flex-direction: column;   
        justify-content: center;
        height: fit-content;
    }
    .p-4 p  { margin: 0; }    
    .not_asmr {
        font-size: 3.13rem;
        color: #00aeef;
        border-bottom: 3px solid;
        width: fit-content;
        margin: 0 auto !important;
    }
    .p-5 {
        background: url(${(props) => props.spyEle === 'war' || props.spyEle === 'morning' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg3.d83873845c6de2d84ab4.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg3.9e252a8d2901d6534975.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .p-5 .comm, .p-15 .comm {
        text-align: left;
        padding-left: 3%;
        margin: 0;
        align-items: flex-start;
    }
    .p-6 {
        background: url(${(props) => props.spyEle === 'war' || props.spyEle === 'morning' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg4.1d8f7256e626f6704939.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg4.5e9f1d8c48a133f5d7ae.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .p-6 .comm, .p-16 .comm {
        text-align: right;
        margin: 0;
        align-items: flex-end;
    }
    .p-7 {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg5.ca923dfac0124cbb102d.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .p-8 {
        background: url(${(props) => props.spyEle === 'war' || props.spyEle === 'morning' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg6.21204278413c6538d015.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg5.d5fe5229a653f80960f2.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .p-8 .comm-tit, .p-18 .comm-tit {
        background: none;
        color: #00aeef;
        font-size: 2.815rem;
        margin: 0 0 .5rem 0px;
    }

    .p-11-m {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg1.aec79790ab7536378af5.jpg" }) no-repeat center / cover
    }
    .p-11-b {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg1.8ff9151aa7e3f038f5a1.jpg" }) no-repeat center / cover
    }
    .p-11-w {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg1.03acc6ed42ccc20b6d3c.jpg" }) no-repeat center / cover
    }

    .p-12 {
        background: url(${(props) => props.spyEle === 'morning' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg2.72abce6ec29b9746ead0.jpg" : props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg2.282039b45176b8d987c1.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg2.57615c1617020efc5dc6.jpg" }) no-repeat center / cover;
    }
    .p-13 {
        background: url(${(props) => props.spyEle === 'morning' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg3.4da968b1754854bd0310.jpg" : props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg3.ad4a8d4d04a85e361bda.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg3.0874478cfc0e7fdcb6f1.jpg" }) no-repeat center / cover;
        flex-direction: column; 
    }
    .p-14 {
        background: url(${(props) => props.spyEle === 'morning' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg4.7fcefbd1ad9b2c462e36.jpg" : props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg4.18f95f6e228900a24ead.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg4.f1012d40780a1b8ed711.jpg" }) no-repeat center / cover;
        flex-direction: column;   
    }
    .p-15 {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg5.433358950274c938eb65.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .p-16 {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg6.0680848bd0c55e96e7d9.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .p-18 {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg7.f57cc9f262540afb684b.jpg" }) no-repeat center / cover;
        flex-direction: row;
    }
    .footer-1 {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/end_bg1.9ad8884b51d72f5f96ae.jpg" }) no-repeat center / cover;
    }
    .footer-1 .comm p, .footer-2 .comm p {margin: 1rem;}
    .footer-1 .comm, .footer-2 .comm { font-size: 3.13rem; }
    .footer-1 .comm span, .footer-2 .comm span { color: #00aeef; }
    .footer-2 .comm button div {
        width: fit-content;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .footer-1 .comm button, .footer-2 .comm button, .another-asmr {
        width: 25rem !important;
        font-size: 2.03rem;
        margin: 1rem auto;
        padding: 0.8rem 0;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
    }
    .footer-1 .comm .btn-img polyline, .footer-2 .comm .btn-img polyline { stroke: #fff; }

    .footer-2 {
        background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/end_bg2.c2b2575e874a7a29c98b.jpg" }) no-repeat center / cover;
    }
    .footer-2 .comm-2 { font-size: 2.815rem; }
    .footer-2 .comm-3 {     
        font-family: AggroL,sans-serif;
        font-size: 2.5rem;
        line-height: 3.5rem;
        margin: 0;
    }

    .another-asmr {
        background-color: #1cabe2;
        color:white;
        text-decoration: none;
        font-family: 'Noto Sans KR',sans-serif;
        font-weight: 700;
        line-height: 3rem;
        margin-top: .5rem;
    }

    .another-asmr:hover {
        background-color: #0a70ea;
    }

    @keyframes bounce { 
        0% { transform: translate(0, 0); } 
        50% { transform: translate(0, -10px); } 
        100% { transform: translate(0, 0px); } 
    }

    @media (max-width: 720px) {        
        nav a {
            font-size: 2.1rem;
            padding: 2rem 0;
        }    
        .main-inner { justify-content: center; }
        .main-inner img { width: 8.3rem; }

        .main-comm h1 {font-size: 3.13rem; }
        .main-comm p { 
            font-size: 2.3rem;
            line-height: 3rem; 
            margin: 2rem 0 2em;
        }
        .comm button {
            margin: 0;
            color: #fff;
            padding: 1rem 2rem;
        }

        .p-1-w {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg1_m.f363e9f7f8a5c0d3e4ea.jpg" }) no-repeat center / cover;
            justify-content: flex-end;
        }
        .p-1-m {
            background: url(${  "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg1_m.13ab885902653367bbb4.jpg" }) no-repeat center / cover;
            justify-content: flex-end;
        }
        .p-3, .p-13 { 
            background: url(${(props) => props.spyEle === 'marriage' || props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg2_m.f967e26b72f8560829bb.png" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg2_m.c5a9ae5c7dab642d878d.png" }) center top 13rem / 42vh no-repeat, rgb(0, 0, 0);
            align-items: center;
            justify-content: flex-end;
        }
        .p-3 .comm {
            text-align: center;
            padding-left: 0;
            padding-top: calc(9rem + 42vh);
            justify-content: flex-start;
            font-size: 2.8rem;
        }
        .t-s .comm p { font-size: 2.9rem; }
        .p-4 .comm {
            height: calc(100% - 13.5rem);
            justify-content: center;
            padding: 0;
        }
        .p-4 .comm > div {
            margin: 0;
            height: fit-content;
            margin-top: -7rem;
        }
        .p-4 .comm > div, .p-14 .comm > div {
            display: flex;
            flex-direction: ${(props) => props.spyEle === 'war' || props.spyEle === "marriage" ? 'column-reverse' : 'column' };
        }
        .p-4 p { 
            margin: 1.5rem 0;
            font-size: 2.8rem;
            line-height: 3.5rem;
            height: calc(100% - 13.5rem);
        }
        .p-5, .p-15 { 
            background: url(${(props) =>  props.spyEle === 'war' || props.spyEle === 'morning' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg3_m.bb42e0d6cc29e1ffab80.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg3_m.ab0e0b0ed4d9ed8d12a1.jpg" }) no-repeat center / cover;
            flex-direction: column;
            justify-content: center;
        }
        .p-5 img {
            max-height: 34%;
            max-width: 95%;
            margin-top: 0;
            align-self: flex-start;
        }
        .p-15 img, .p-16 img {
            max-height: 29%;
            max-width: 95%;
            margin-top: 0;
            align-self: flex-start;
        }
        .p-5 .comm, .p-6 .comm, .p-15 .comm, .p-16 .comm {
            justify-content: flex-start;
            align-items: center;
            text-align: left;
            padding-left: 0;
            text-align: center;
            font-size: 1.74rem !important;
            margin-top: 2.5rem;
            height: fit-content;
        }
        .p-5 .comm-point, .p-6 .comm-point, .p-15 .comm-point, .p-16 .comm-point {
            font-size: 2.3rem;
            line-height: 3.5rem;
        }
        .p-6 img {
            max-height: 34%;
            max-width: 95%;
            margin-top: 0;
            align-self: flex-end;
        }
        .p-6 { 
            background: url(${(props) => props.spyEle === 'war' || props.spyEle === 'morning' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg4_m.ce874a20492163608319.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg4_m.7c207361c8658fa4633b.jpg" }) no-repeat center / cover;
            flex-direction: column-reverse; 
            justify-content: center;
        }    
        .p-7 {  
            background: url( ${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg5_m.896a884cb239a216efb8.jpg" }) no-repeat center / cover;
            flex-direction: row;
        }
        .p-8 {
            background: url(${(props) => props.spyEle === 'war' || props.spyEle === 'morning' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/war_bg6_m.5565c414a5ea7f7cf0c7.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/marr_bg5_m.afdc1646ae91e0e54f06.jpg" }) no-repeat center / cover;
        }
        .p-8 .comm-tit, .p-18 .comm-tit { font-size: 3.13rem; }

        
        .p-11-m {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg1_m.5301f2d103d8e3fc1ff4.jpg" }) no-repeat center / cover
        }
        .p-11-b {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg1_m.9264970d5e12eff49f6d.jpg" }) no-repeat center / cover
        }
        .p-11-w {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg1_m.2dc010d750cabe47f68e.jpg" }) no-repeat center / cover
        }

        .p-12 {
            background: url(${(props) => props.spyEle === 'morning' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg2_m.4d02f804c5da5010aaec.jpg" : props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg2_m.d08cdcf245db609efea6.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg2_m.528fadc5f4aeaed3ee83.jpg" }) no-repeat center / cover;
        }
        .p-13 {
            background: url(${(props) => props.spyEle === 'morning' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg3_m.06394ba404d8e22d5861.jpg" : props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg3_m.cf0b0de31ea408b30fe6.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg3_m.469843bdb0b0e05da477.jpg" }) no-repeat center / cover;
        }
        .p-14 {
            background: url(${(props) => props.spyEle === 'morning' || props.spyEle === '' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg4_m.a06f5d8879c4e4e0ba6d.jpg" : props.spyEle === 'birthday' ? "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/bday_bg4_m.a69535677cf6c5698a19.jpg" : "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg4_m.362e5ff998204cb12aa9.jpg" }) no-repeat center / cover;
        }
        .p-15 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg5_m.ea99f961f33e62466afe.jpg" }) no-repeat center / cover;
        }
        .p-16 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg6_m.b01f90dbe06210b0692d.jpg" }) no-repeat center / cover;
            flex-direction: column-reverse; 
        }
        .p-18 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/weekend_bg7_m.10c268f8fc9e71dab287.jpg" }) no-repeat center / cover;
        }
        .footer-1 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/end_bg1_m.1b379b86d77db3e3a4e8.jpg" }) no-repeat center / cover;
        }
        .footer-2 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/end_bg2_m.9eeb7de56a658cc6e6d8.jpg" }) no-repeat center / cover;
        }

        .footer-2 .comm-2, .footer-2 .comm-3 {font-size: 2.3rem;}
    }
`;

export const Container = styled.div`
    width: inherit;
    height: 100vh;
    min-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .copyright {
        font-family: "Noto Sans KR",sans-serif;
        position: absolute;
        bottom: 5%;
        left: 2%;
        font-size: 1.07rem;
        writing-mode: vertical-lr;
        transform: rotate(180deg);
        color: #bebebe;
    }

    .comm {
        color: #fff;
        font-size: 2.815rem;
        font-family: AggroB, sans-serif;
        text-align: center;
        line-height: 4rem;
        letter-spacing: .03rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 6rem;
    }
    .comm-basic {
        font-family: "Noto Sans KR", sans-serif;
        font-size: 1.9rem;
        line-height: 2.5rem;
        margin: 0.5rem 0px;
    }
    .comm button {
        font-size: 2rem;
        margin: 2rem 0 0 0;
        padding: 0.9rem 1.8rem 1rem;
    }

    .p-w-bg {
        color: #000;
    }
    .p-w-bg span {
        background-color: #1cabe2;
        color: #fff;
        padding: 0.3rem 0.5rem 0;
    }
    .p-w-bg button {
        background-color: #000;
        color: #fff;
        font-size: 2rem;
        margin: 2rem auto;
        width: fit-content;
    }
    .p-w-bg button:hover {
        background-color: #0a70ea;
    }

    .comm-point {
        margin: 0;
        font-family: AggroL, sans-serif;
        font-style: italic;
        color: #00aeef;
        line-height: 4rem;
    }
    .comm-point2 {        
        font-style: initial;
        font-size: 1.9rem;
        line-height: 3rem;
        margin: 0;
    }
    .comm-point span {
        font-family: AggroB, sans-serif;
        font-style: normal;
        background: linear-gradient(to right, #00aeef, #b4eaff);
        color: transparent;
        -webkit-background-clip: text;
    }

    video {
        width: 51rem;
        margin: 1rem auto 0;
        display: block;
    }

    & button {
        background-color: #1cabe2;
        color: #fff;
        border: 0 !important;
        font-size: 2.19rem;
        margin: 0;
        width: fit-content;
    }
    & button:hover {
        background-color: #0a70ea;
    }

    .scroll-cont {
        margin-bottom: 2.5em;
        position: absolute;
        bottom: 0;
        transform: translate(-50%,-50%);
        animation: bounce .6s linear infinite;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .scroll-cont p {
        font-family: 'SUIT', sans-serif;
        font-size: 1.07rem;
    }
    .scroll-cont img { width: 3rem; }


    .scroll_img {
        width: 8rem;
        margin-bottom: 2.5em;
        position: absolute;
        bottom: 0;
        transform: translate(-50%, -50%);
        animation: bounce .6s linear infinite;
    }

    @media (max-width: 1400px) {        
        video {
            width: 64rem;
            margin: 3rem auto 0;
        }
    }

    @media (max-width: 1400px) {        
        video {
            width: 64rem;
            margin: 3rem auto 0;
        }
    }

    @media (max-width: 720px) {
        .scroll-cont p { font-size: 1.35rem; }

        .copyright {
            bottom: 2%;
            left: 3%;
            writing-mode: initial;
            transform: none;
        }

        min-height: none;
        .comm {
            font-size: 3.13rem;
            line-height: 4rem;
            height: calc(100% - 13.5rem);
        }
        .comm-point2 { 
            font-size: 2rem;
            line-height: 1.4;
        }
        .comm-point3{ 
            font-size: 1.7rem;
            line-height: 2rem;
        }
        .comm-basic { line-height: 3rem; }
        
        video {
            width: 90%;
            margin: 2rem auto 0;
        }
        & button {
            padding: 1.3rem 3.5rem;
            font-size: 2.1rem;
        }
    }
`;

export const Container2 = styled.div`
    width: inherit;
    height: 100vh;
    min-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    .p-13 .comm, .p-14 .comm { margin-top: -18rem; }

    .wrong {animation: vibration .1s ease-in-out infinite;}
    @keyframes vibration  { 
        from {
            transform: rotate(1deg);
        }
        to {
            transform: rotate(-1deg);
        }
    }
    
    .copyright {
        font-family: "Noto Sans KR",sans-serif;
        position: absolute;
        bottom: 5%;
        left: 2%;
        font-size: 1.07rem;
        writing-mode: vertical-lr;
        transform: rotate(180deg);
        color: #bebebe;
    }    

    & .scroll-cont {
        margin-bottom: 2.5em;
        position: absolute;
        bottom: 0;
        transform: translate(-50%,-50%);
        animation: bounce .6s linear infinite;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    & .scroll-cont p {
        font-family: 'SUIT', sans-serif;
        font-size: 1.07rem;
    }
    & .scroll-cont img { width: 3rem; }

    & .scroll_img {
        width: 8rem;
        margin-bottom: 2.5em;
        position: absolute;
        bottom: 0;
        transform: translate(-50%, -50%);
        animation: bounce .6s linear infinite;
    }

    & .scroll_img2 {
        width: 3rem;
        margin-bottom: 2.5em;
        position: absolute;
        bottom: 10%;
        transform: translate(-50%, -50%);
        animation: bounce .6s linear infinite;
    }
    
    &.item-right { justify-content: flex-start; }
    &.item-right .comm { 
        align-self: flex-end;
        padding-left: 0;
        padding-right: 9%;
        text-align: right;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        margin-top: 15rem;
    }
    .comm {
        color: #fff;
        font-size: 3.63rem;
        font-family: AggroB, sans-serif;
        text-align: left;
        line-height: 4rem;
        padding-left: 9%;
        align-self: flex-start;
    }
    .p-w-bg {
        color: #000;
        line-height: 1rem;
    }
    .p-w-bg span {
        background-color: #1cabe2;
        color: #fff;
        padding: 0.3rem 0.5rem 0;
    }
    .comm-point span {
        font-family: AggroB, sans-serif;
        font-style: normal;
        background: linear-gradient(to right, #00aeef, #b4eaff);
        color: transparent;
        -webkit-background-clip: text;
    }

    & button {
        background-color: #1cabe2;
        color: #fff;
        border: 0 !important;
    }
    & button:hover {
        background-color: #0a70ea;
    }

    .opacity { opacity: 0.3; }

    .label-cont {
        display: flex;
        flex-direction: column;
        width: fit-content;
    }
    
    &.item-right .label-cont {
        align-items: flex-end;
    }
    label {
        display: flex;
        align-items: center;
        font-size: 3.15rem;
        cursor: pointer;
        width: fit-content;
    }
    label:first-child { margin-bottom: .3rem; }
    label input[type=checkbox] { 
        display: inline-block;
        cursor: pointer;
        max-width: 3.63rem;
        max-height: 3.25rem;
        width: 3.63rem;
        height: 3.25rem;
        appearance: none;
        margin: 0 1.7rem 0 0;
        background: url(${ check_box }) no-repeat center / cover;
    }
    label.correct input[type=checkbox]:checked { background-image: url(${ check }); }
    
    &.item-right label { justify-content: flex-end; }
    &.item-right label input[type=checkbox] { margin: 0 0 0 1.7rem; }
    &.item-right label.correct input[type=checkbox]:checked { background-image: url(${ check2 }); }

    @media (max-width: 720px) {
        & .scroll-cont p { font-size: 1.35rem; }
        .copyright {
            bottom: 2%;
            left: 3%;
            writing-mode: initial;
            transform: none;
        }
        .copyright-r {
            left: auto;
            right: 3%;
            bottom: 45%;
            writing-mode: vertical-rl;
        }

        justify-content: flex-end;

        &.p-1 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg1_m.5301f2d103d8e3fc1ff4.jpg" }) no-repeat center / cover
        }
        &.p-2 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg2_m.4d02f804c5da5010aaec.jpg" }) no-repeat center / cover
        }
        &.p-3 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg3_m.06394ba404d8e22d5861.jpg" }) no-repeat center / cover
        }
        &.p-4 {
            background: url(${ "https://cdn.unicef.or.kr/images/22unicef-asmr/static/media/morning_bg4_m.a06f5d8879c4e4e0ba6d.jpg" }) no-repeat center / cover
        }
        
        .comm {
            font-size: 3.13rem;
            line-height: 4rem;
            margin-bottom: 39%;
        }
        .comm p {
            margin: 0 0 1rem 0;
        }
        .comm label {
            font-size: 2.431rem;
        }

        &.item-right .comm { text-align: right; }
        &.item-right label { justify-content: flex-end;}
        &.item-right { justify-content: flex-end;}
        
        video {
            width: 90%;
        }
        & button {
            padding: 1.3rem 3.5rem;
            font-size: 2.1rem;
        }
    }
`;

export const IntroContainer = styled.div`
    width: 100%;
    height: 100vh;
    min-height: 800px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;    
    align-items: center;
    
    .intro-tit { margin-top: 3%;}
    .intro-tit h1 {
        font-family: AggroB,sans-serif;
        text-align: center;
        font-size: 3.13rem;
        color: #00aeef;
        width: fit-content;
        margin: 0 auto;
        border-bottom: 3px solid #00aeef;
        padding-bottom: 5px;
    }
    .intro-tit p {
        font-family: AggroB,sans-serif;
        text-align: center;
        font-size: 2.815rem;
        margin: 3rem auto 0;
    }

    .intro-img-cont {
        display: flex;
        flex-direction: column;
        width: 66%;
        margin: 1.5rem auto 0;
    }
    .intro-img-cont > div { position: relative; }
    .intro-img1 { 
        align-self: flex-start;
        margin-top: 0;
        width: 38rem;
    }
    .intro-img-cont p {
        font-family: AggroL, sans-serif;
        font-size: 2.2rem;
    }
    .intro-img-cont p > span { font-family: AggroM, sans-serif; }
    .intro-img1 img, .intro-img2 img { width: 100%; }
    .intro-img1 p { 
        display: inline-block;
        position: absolute;
        right: -28%;
        top: 15%;
    }
    .intro-img1 p span, .intro-img2 p span {
        font-family: AggroM, sans-serif;
        color: #00aeef;
    }
    .intro-img2 { 
        align-self: flex-end;
        margin-right: -8rem;
        margin-top: -17rem;
        width: 47rem;
    }
    .intro-img2 p { 
        display: inline-block;
        position: absolute;
        left: -39%;
        bottom: 14%;
        text-align: right;
    }

    &.footer .intro-img-cont {
        width: 75%;
        margin: 7.5rem auto 0;
    }
    &.footer .intro-img1 p {
        right: -99%;
        top: -8%;
        line-height: 3rem;
    }
    &.footer .intro-img2 p {
        left: -91%;
        bottom: 2%;
        line-height: 3rem;
    }
    
    @media (max-width: 720px) {
        padding: 2rem 0;
        box-sizing: border-box;

        .intro-tit h1 {font-size: 3rem;}
        .intro-tit p {font-size: 2.5rem;}
        .intro-img-cont {
            width: 100%;
            overflow: hidden;
        }
        .intro-img-cont p { font-size: 1.7rem; }

        .intro-img1 { width: 28rem; }
        .intro-img1 p {
            right: -15%;
            top: 29%;
        }
        .intro-img2 {
            margin-right: 0;
            margin-top: -10rem;
            width: 29rem;
        }
        .intro-img2 p {
            left: -22%;
            bottom: 31%;
        }

        &.footer .intro-tit {
            margin-top: 12%;
        }
        &.footer .intro-img-cont { 
            width: 100%;
            height: 100%; 
            margin: 3.5rem auto 0;
            justify-content: space-evenly;
        }
        &.footer .intro-img1 { width: 25rem; }
        &.footer .intro-img2 { margin-top: -4%; }
        &.footer .intro-img1 p {
            right: calc(100% - 48rem);
            top: auto;
            bottom: -7%;
            text-align: right;
        }
        &.footer .intro-img1 { width: 29rem; }
        &.footer .intro-img2 p {
            left: calc(100% - 48rem);
            bottom: 0;
            text-align: left;
        }
    }
`;

export const ShareContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;    
    align-items: center;
    padding: 2rem 0;
    overflow: hidden;
    box-sizing: border-box;

    .share-img-cont { display: flex; }
    
    .share-img-cont > div { margin: 0 1.5rem; }
    .share-img-cont img { width: 23.8rem; }
    .share-img-cont a {
        display: flex;
        align-items: center;
        width: fit-content;
        margin: 1rem auto 0;
        text-decoration: none;
        color: #000;
        background: #fff;
        padding: 0.5rem 1rem;
        font-size: 1.4rem;
        border-radius: 42px;
        font-family: 'Noto Sans KR',sans-serif;
    }
    .share-img-cont a > img {
        width: 1rem;
        margin-right: 0.5rem !important;
    }
    p {
        margin: 3rem 0 0;
        text-align: center;
        font-size: 2.19rem;
        font-family: AggroL,sans-serif;
        line-height: 3.3rem;
    }
    p.share-comm-bold {
        font-family: AggroM, sans-serif;
        margin: 0;
    }

    .share-btn-cont {
        margin-top: 2rem;
        background: #fff;
        display: flex;
        align-items: center;
        padding: 1rem 2rem;
        border-radius: 100px;
    }

    .share-btn-cont button {
        cursor: pointer;
        border: 0; 
        background: transparent;
        margin: 0;
        padding: 0 0.4rem;
        width: fit-content;
        line-height: 1rem;
    }
    .share-btn-cont button img { width: 3rem; }
    .share-btn-cont span {
        font-size: 2.13rem;
        font-weight: 800;
        font-family: 'SUIT', sans-serif;
        color: #000;
        margin-left: 1rem;
        display: flex;
        align-items: center;
    }

    .share-slider-cont {
        width: 100%;
        margin-top: 36%;
    }
    
    @media (max-width: 720px) {
        .share-slider-cont { margin-top: 0; }

        a {
            border-radius: 5px;
            font-weight: bold;
            padding: .7rem 2rem;
            font-size: 1.7rem;
            margin-top: 3rem;
        }
        p {
            font-size: 2.4rem;
            margin-top: 2.5rem;   
            line-height: 3rem;
        }

        .slick-slide img { 
            margin: 0 auto !important;
            width: 55%;
        }
        .slick-next {
            right: -10%;
            top: 50%;
            margin: 0;
            padding: 0;
            height: 100%;
            border: 0;
            color: transparent;
        }
        .slick-prev {
            top: 50%;
            left: 0%;
            display: block;
            margin: 0;
            padding: 0;
            height: 100%;
            border: 0;
            color: transparent;
        }
        .slick-prev:before, .slick-next:before {
            font-size: 4rem;
            opacity: 1;
        }
        .share-btn-cont button img {
            width: 4.5rem;
        }
        .share-img-cont a { border-radius: 3px; }
    }
`;

export const FooterContainer = styled.div`
    width: 100%;
    height: 16.13rem;
    background: #151A1F;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .footer-comm {
        color: #E2E2E3;
        font-size: 1.063rem;
        line-height: 1.8rem;
        text-align: center;
    }
    .footer-pc { display: inline-block; }

    @media (max-width: 720px) {
        .footer-comm { font-size: 1.042rem; }
        .footer-pc { display: none; }
    }
`;